// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1HDb9","dragIcon":"Choice_dragIcon__1gjI6","left":"Choice_left__2J2ga","input":"Choice_input__XQGWs"};